<template>
    <div class="designerpage">
        <north-east-panels-designer-question-door-range v-if="range_panel_required"
                                         :fabricator="fabricator"
                                         v-model:target="door.attr.door_range"
                                         :ranges="ranges"
                                         :defaults="defaults()"
                                         title="Choose a Door Range"
                                         :reference_on="reference_on"></north-east-panels-designer-question-door-range>

        <doorco-designer-question-select-frame-style :fabricator="fabricator"
                                                     :is-firedoor="is_firedoorrange"
                                              v-model:target="door.attr.frame_style"></doorco-designer-question-select-frame-style>

        <div class="designeroption">
            <doorco-designer-question-select-door :fabricator="fabricator"
                                           :secured-by-design="door.attr.secured_by_design"
                                           :door-range="door.attr.door_range"
                                           v-model:target="door.attr.slab"></doorco-designer-question-select-door>
        </div>
        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>
        <div class="designeroption">
            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>
        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                            v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                  title="External Door Colour"
                                                  v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                </div>
                <div id="dc-tabs-2">
                    <wb-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                            :external-colour="door.attr.external_colour"
                                                            v-model:target="door.attr.door_colour_internal"></wb-designer-question-door-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                  title="Internal Door Colour"
                                                  v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour">
            <h3>Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                             v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                                  title="External Frame Colour"
                                                  v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
                </div>
                <div id="tabs-2">
                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                             :frame-colour-external="door.attr.frame_colour_external"
                                                             v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                                  title="Internal Frame Colour"
                                                  v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div class="designeroption" v-show="technical_should_show">
            <designer-question-secured-by-design :fabricator="fabricator"
                                                 v-model:target="door.attr.secured_by_design"></designer-question-secured-by-design>
        </div>

        <div v-show="technical_should_show">
            <designer-question-door-glass-laminated :fabricator="fabricator"
                                                    v-model:target="door.attr.laminated_glass"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :side-panels="door.attr.side_panels"
                                                    :frame-style="door.attr.frame_style"
                                                    :door_range="door.attr.door_range"
            ></designer-question-door-glass-laminated>
        </div>

<div class="designeroption"><wb-designer-question-glass-design :fabricator="fabricator"
v-model:target="door.attr.glass_design"
:laminated-glass="door.attr.laminated_glass"
:door-range="door.attr.door_range"
:slab="door.attr.slab"></wb-designer-question-glass-design></div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                v-model:target="door.attr.glass_backing_design"
                                                :slab="door.attr.slab"
                                                :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>


        <doorco-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                   v-model:target="door.attr.side_panels"
                                                   :door-range="door.attr.door_range"
                                                   :frame-style="door.attr.frame_style"
                                                   :frame-profile="door.attr.profile"
                                                   :frame-material="door.attr.frame_material"
                                                   :laminated-glass="door.attr.laminated_glass"
                                                   :frame-colour-internal="door.attr.frame_colour_internal"
                                                   :frame-colour-external="door.attr.frame_colour_external"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :slab="door.attr.slab"
                                                   :measurements.sync="door.attr.measurements"></doorco-designer-question-select-frame-sidepanels>

        <div class="designeroption">
            <wb-designer-question-hardware-colour :fabricator="fabricator"
                                               v-model:target="door.attr.hardware_colour"
                                               :sbd="door.attr.secured_by_design"
                                               :slab="door.attr.slab"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour>
        </div>
        <div class="designeroption">
            <wb-designer-question-hardware-handle :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"></wb-designer-question-hardware-handle>
            <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle_split_spindle"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>
        </div>

<div class="designeroption"><wb-designer-question-hardware-escutcheon :fabricator="fabricator"
v-model:target="door.attr.hardware_escutcheon"
:slab="door.attr.slab"
:secured-by-design="door.attr.secured_by_design"
:hardware-colour="door.attr.hardware_colour"
:hardware-handle="door.attr.hardware_handle"
:door-range="door.attr.door_range"
:profile="door.attr.profile"></wb-designer-question-hardware-escutcheon><designer-question-hardware-escutcheon-position :fabricator="fabricator"
v-model:target="door.attr.hardware_escutcheon_pos"
:slab="door.attr.slab"
:frame-material="door.attr.frame_material"
:hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position></div>

        <div class="designeroption" v-show="technical_should_show">
            <doorco-designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :door-range="door.attr.door_range"></doorco-designer-question-hardware-lock>
        </div>

        <div class="designeroption" v-show="technical_should_show">
            <designer-question-hardware-cylinder :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    :slab="door.attr.slab"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-cylinder>
        </div>

        <div class="designeroption" v-show="technical_should_show">
            <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_hinge"
                                                 :slab="door.attr.slab"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :frame-material="door.attr.frame_material"
                                                 :door-range="door.attr.door_range"></wb-designer-question-hardware-hinge>
        </div>

        <div class="designeroption" v-show="technical_should_show">
            <wb-designer-question-hardware-security-chain :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"></wb-designer-question-hardware-security-chain>
        </div>
        <div class="designeroption">
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
        </div>

<div class="designeroption"><wb-designer-question-hardware-spy-hole :fabricator="fabricator"
v-model:target="door.attr.hardware_spy_hole"
:slab="door.attr.slab"
:secured-by-design="door.attr.secured_by_design"
:glass-design="door.attr.glass_design"
:hardware-handle="door.attr.hardware_handle"
:hardware-knocker="door.attr.hardware_knocker"
:hardware-colour="door.attr.hardware_colour"
:door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole><designer-question-hardware-spy-hole-position :fabricator="fabricator"
v-model:target="door.attr.hardware_spy_hole_pos"
:slab="door.attr.slab"
:frame-material="door.attr.frame_material"
:hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position></div>

<div><wb-designer-question-hardware-knocker :fabricator="fabricator"
v-model:target="door.attr.hardware_knocker"
:slab="door.attr.slab"
:hardware-handle="door.attr.hardware_handle"
:hardware-spyhole="door.attr.hardware_spy_hole"
:hardware-colour="door.attr.hardware_colour"
:door-range="door.attr.door_range"></wb-designer-question-hardware-knocker><designer-question-hardware-knocker-position :fabricator="fabricator"
v-model:target="door.attr.hardware_knocker_pos"
:slab="door.attr.slab"
:frame-material="door.attr.frame_material"
:hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position></div>

        <div class="designeroption">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 title="Numerals"></designer-question-hardware-numerals>
        </div>
        <div class="designeroption" v-show="technical_should_show">
            <designer-question-technical-profile :fabricator="fabricator"
                                                 :frame-colour-internal="door.attr.frame_colour_internal"
                                                 :frame-colour-external="door.attr.frame_colour_external"
                                                 :frame-material="door.attr.frame_material"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                 :opening-direction="door.attr.opening_direction"
                                                 v-model:target="door.attr.profile"></designer-question-technical-profile>
        </div>
        <div class="designeroption" v-show="technical_should_show">
            <designer-question-addons :fabricator="fabricator"
                                      v-model:target="door.attr.addons"
                                      :frame-profile="door.attr.profile"
                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                      :frame-colour-external="door.attr.frame_colour_external">

            </designer-question-addons>
        </div>

        <designer-question-technical-threshold :fabricator="fabricator"
                                               v-model:target="door.attr.threshold"
                                               :frame-colour-internal="door.attr.frame_colour_internal"
                                               :frame-colour-external="door.attr.frame_colour_external"
                                               :opening-direction="door.attr.opening_direction"
                                               :frame-profile="door.attr.profile"
                                               :door-range="door.attr.door_range"></designer-question-technical-threshold>

        <designer-question-door-drip-colour :fabricator="fabricator"
                                            title="Choose A Door Drip Bar colour"
                                            :external-colour="door.attr.external_colour"
                                            v-model:target="door.attr.door_drip_colour"
                                            :frame-profile="door.attr.profile"></designer-question-door-drip-colour>

        <div class="designeroption" v-show="technical_should_show">
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-drainage :fabricator="fabricator"
                                                  v-model:target="door.attr.drainage"
                                                  :cill="door.attr.cill"
                                                  :threshold="door.attr.threshold"></designer-question-technical-drainage>
        </div>
        <div class="designeroption" v-show="technical_should_show">
            <designer-question-measurements title="Measurements Section"
                                            :fabricator="fabricator"
                                            :slab="door.attr.slab"
                                            :external-colour="door.attr.external_colour"
                                            :internal-colour="door.attr.door_colour_internal"
                                            :frame-profile="door.attr.profile"
                                            :threshold="door.attr.threshold"
                                            :frame-id="door.attr.frame_style.frame_id"
                                            :side-panels="door.attr.side_panels"
                                            :addons="door.attr.addons"
                                            :cill="door.attr.cill"
                                            :hardware-lock="door.attr.hardware_lock"
                                            :hardware-hinge="door.attr.hardware_hinge"
                                            :hardware-handle="door.attr.hardware_handle"
                                            :hardware-knocker="door.attr.hardware_knocker"
                                            :hardware-spy-hole="door.attr.hardware_spy_hole"
                                            :hardware-escutcheon="door.attr.hardware_escutcheon"
                                            :hardware-letterbox="door.attr.hardware_letterbox"
                                            :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                            :mdd="mdd"
                                            :technical_should_show="technical_should_show"
                                            v-model:target="door.attr.measurements"></designer-question-measurements>

        </div>


        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control" value="Retail Door">

      <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        props:{

        },
        computed: {
            is_firedoorrange(){
                return false;
                // return this.door.attr.door_range === 36;
            },
        },
        methods: {
          defaults() {
            return {
              114: {
                "attr": {
                  "fabricator": 28,
                  "door_range": 114,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "hardware_colour": 22,
                  "hardware_handle": 1051,
                  "hardware_hinge": 128,
                  "hardware_suite": 20,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1218,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1358,
                  "hardware_cylinder": 1873,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 7856,
                  "threshold": 7852,
                  "side_panels": {
                    "left_composite_id": 1422,
                    "right_composite_id": 1422,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 9,
                    "right_panel_glass_id": 9,
                    "top_panel_glass_id": 9,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 3,
                  "notes": "",
                  "measurements": {
                    "overall_width": null,
                    "overall_height": null,
                    "left_width": null,
                    "right_width": null,
                    "top_box_drop": null
                  },
                  "reference": "",
                  "hardware_handle_split_spindle": 424,
                  "door_drip_colour": 1
                }
              },
            };
          },
        }
    }
</script>
